/**
 * Routes that own the whole viewport: the shell hides the widget dock (desktop + mobile) and the
 * mobile bottom nav there. Mimic pass-and-play (the phone is handed around the table) and Card
 * Table rooms (phones can't spare the ~190 px the nav + dock take; the page has its own exit).
 */
const CARD_TABLE_ROOM = /^\/games\/tabletop\/rooms\/\d{8}\/?$/;
const FULL_BLEED: readonly RegExp[] = [
  /^\/games\/mimic\/local\/?$/,
  CARD_TABLE_ROOM,
];

export function isFullBleedRoute(pathname: string): boolean {
  return FULL_BLEED.some((re) => re.test(pathname));
}

/**
 * Routes where touch devices that get the desktop tree (landscape phones, tablets) also lose the
 * desktop app bar: a 390 px-tall landscape phone can't spare it and the page has its own bar.
 * Card Table rooms only — Mimic pass-and-play keeps its app bar.
 */
export function hidesAppBarOnTouch(pathname: string): boolean {
  return CARD_TABLE_ROOM.test(pathname);
}
